import React, { useEffect } from 'react';
import { useAuthContext } from '../../context/auth-context';

declare global {
  interface Window {
    LiveAgent: any;
  }
}

const ChatWidget: React.FC = () => {
  const { user } = useAuthContext();

  useEffect(() => {
    if (!user) return;

    const scriptId = 'la_x2s6df8d';
    let script = document.getElementById(scriptId) as HTMLScriptElement;

    const initLiveAgent = () => {
      const LiveAgent = window.LiveAgent;
      if (LiveAgent) {
        LiveAgent.clearAllUserDetails();
        LiveAgent.addUserDetail("firstName", user.firstName || user.username || "");
        LiveAgent.addUserDetail("lastName", user.lastName || "");

        // Avoid creating duplicate buttons if one already exists
        const existingButton = document.querySelector('.animated3DButton');
        if (!existingButton) {
          LiveAgent.createButton('08nyz33m', script);
        }

        // TC-788 wait for button and then adjust its parent
        const moveChatButton = () => {
          const chatButtons = document.querySelectorAll('.animated3DButton');
          if (chatButtons.length > 0) {
            chatButtons.forEach((chatButton, index) => {
              const chatButtonParent = chatButton.parentElement as HTMLElement;
              if (chatButtonParent) {
                // If we somehow have more than one, hide the additional ones
                if (index > 0) {
                  chatButtonParent.style.display = 'none';
                  return;
                }
                chatButtonParent.style.removeProperty('right');
                chatButtonParent.style.left = '50%';
                chatButtonParent.style.bottom = '-30px';
                chatButtonParent.style.transform = 'translateX(-50%)';
                console.log("LiveAgent chat button moved (index: " + index + ")");
              }
            });
          } else {
            // retry if button is not ready
            setTimeout(moveChatButton, 100);
          }
        };
        moveChatButton();
      }
    };

    if (!script) {
      script = document.createElement('script');
      script.id = scriptId;
      script.async = true;
      script.src = 'https://touringcars.ladesk.com/scripts/track.js';
      script.onload = initLiveAgent;
      document.body.appendChild(script);
    } else {
      if (window.LiveAgent) {
        initLiveAgent();
      } else {
        script.addEventListener('load', initLiveAgent);
      }
    }
  }, [user]);

  return null;
};

export default ChatWidget;
